import React from 'react';
import { useLocation } from 'react-router-dom';
import BookLocationPage from './BookLocationPage';
import FullScreenDialog from '../../common/FullScreenDialog';
import { useGetLocationListQuery } from "../../../api/locations/locationsApiSlice";
import { useBookingFlowLifecycle } from "../common/hooks/useBookingFlowLifecycle";
import { useBookingUrlState } from "../common/hooks/useBookingUrlState";
import { useIsObjectFirst } from "../common/hooks/useObjectFirstEntry";

interface BookLocationDialogProps {
    open: boolean;
    locationId?: string;
}


const RoomRentalDialog = (props: BookLocationDialogProps) => {
    const location = useLocation();
    const { returnPage } = location.state || {};

    // Note: It's currently important that BookLocationPage is only mounted when location is available
    // due to body scroll locking

    const { data: locations } = useGetLocationListQuery("apartment");

    // Lifecycle must run before URL state: checkInDate/checkOutDate reducers
    // gate nextEnabled on the flow's use case being a stay (`flowUseCase` of
    // `state.useCase`, here "room"), which lifecycle sets.
    useBookingFlowLifecycle({ useCase: "room", locations });
    useBookingUrlState({ pinObjectId: useIsObjectFirst("apartment") });

    return (
        <FullScreenDialog open={props.open}>
            {<BookLocationPage returnPage={returnPage} />}
        </FullScreenDialog>
    );
};

export { RoomRentalDialog };
